/*
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-08-23 15:35:56
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-23 16:42:30
 * @FilePath: /genetron-web/genetron-h5/src/api/wxapi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {get, post } from "@/axios/http";
/** 医保药物数据库 */
const findGroup = data => post('/knowledgeBase/medicare/findGroup', data);
const findByDrugNameList = data => post('/knowledgeBase/medicare/findByDrugNameList', data);
// 临床招募
const FindByList = data => post('/brave/clinicRecruitment/findByList', data);
const findTissueChAndDrugList = data => post('/brave/clinicRecruitment/findTissueChAndDrugList', data);
// 变异相关临床试验
const findConditionList = data => post('/brave/clinical/findConditionList', data);
const findTissueChAndDrugListTest = data => post('/brave/clinical/findTissueChAndDrugList', data);

/**慈善药物 */
const cishanDrug = data => post('/knowledgeBase/charity/findByDrugNameList', data);
const cishanGroup = data => post('/knowledgeBase/charity/findGroup', data);
/**可能影响免疫治疗疗效的基因检测结果 */
const groupImmuneGene = data => post('/brave/knowledge/groupImmuneGene', data);
const findImmuneGeneList = data => post('/brave/knowledge/findImmuneGeneList', data);
/**基因解读 */
const findGeneDepict = data => post('/brave/gene/unscramble/findGeneDepict', data);
/**位点解读 */
const findAnalysis = data => post('/brave/gene/unscramble/findAnalysis', data);
// 查询患者信息
const findPatientMessage = data => get('/brave/patient/findPatientMessage', data);
// 既往诊断结果
const updateDiagnoseResult = data => post('/brave/diagnose/updateDiagnoseResult', data);
export {
    findPatientMessage,
    findGroup,
    findByDrugNameList,
    FindByList,
    findTissueChAndDrugList,
    cishanDrug,
    cishanGroup,
    groupImmuneGene,
    findImmuneGeneList,
    findAnalysis,
    findGeneDepict,
    updateDiagnoseResult,
    findConditionList,
    findTissueChAndDrugListTest
    
}